export enum CurrencyExchangeSource {
  Hybrid = 'hybrid',
  Rapira = 'rapira',
  Bybit = 'bybit',
  Binance = 'binance',
  Garantex = 'garantex',
  Xe = 'xe',
  ABCEX = 'abcex',
  HTX = 'htx',
  CBR = 'cbr',
  Grinex = 'grinex',
  Mosca = 'mosca',
  Manual = 'manual',
}
